const styles = {
  filterRow: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
  },
  filterLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
};

export default styles;
